export default "__VITE_ASSET__c736af67__"